<template lang="pug">
  .chart-view
    .ma-12
      DataCard(
        :props = "chart"
        rows="1"
        show-nav
        hover-details
        @click="dialog=true"
      )
</template>

<script>
import DataCard from "@/components/Chartcard.vue";
import data from "./data";

export default {
  data: () => ({
    chart: Object
  }),
  components: {
    DataCard
  },
  mounted() {
    this.chart = data.filter(d=> {return d.component.name.toLowerCase() === this.$route.params.component.toLowerCase()})[0];
  },
  computed: {}
};
</script>

<style lang="stylus">
.chart-view {
  
}
</style>